'use strict';

import Backbone from 'backbone';
import * as BomService from '../../services/BomService';

export default class BomCollection extends Backbone.Collection {
  modelId(attrs) {
    return attrs.bomId;
  }

  // Override the collection fetch to use the BomService
  fetch(options = {}) {
    return BomService.getBomsForUser().then(resp => {
      let method = options.reset ? 'reset' : 'set';
      this[method](resp, options);

      if (options.success) {
        options.success(this, resp, options);
      }
    }).catch(err => {
      if (options.error) {
        options.error(this, err, options);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomCollection.js